import { FileReader, FileWriter } from '@/platform'
import FontProperty from './FontProperty'
import Viewport from '../ComControl/Viewport'
import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import GoodPropertyModel from '../GoodPropertyModel'

export enum GoodsTypeEnum {
    Map = 1, // 剧情
    Var = 2, // 数值
    MaxPack = 3, // 大礼包
    Dress = 4 // 装饰
}

export enum GoodsStatus {
    IsUp = 1, // 已上架
    NotUp = 2, // 暂不上架
}

class Goods {
    public GoodsId: number = 0 // 商品ID
    public GoodsName: string = '' // 商品名称
    public GoodsFont: FontProperty = new FontProperty() // 商品名称文字属性
    public GoodsName_X: number = 0 // 商品名称的X坐标
    public GoodsName_Y: number = 0 // 商品名称的Y坐标
    public GoodsType: GoodsTypeEnum = GoodsTypeEnum.Var // 商品类型
    public GoodsPrice: number = 0 // 商品价格
    public GoodsPricePakoras: number = 0 // 商品价格丸子
    public GoodsPriceFont: FontProperty = new FontProperty() // 商品价格文字属性
    public GoodsPrice_X: number = 0 // 商品价格X坐标
    public GoodsPrice_Y: number = 0 // 商品价格Y坐标
    public GoodsIntro: string = '' // 商品信息
    public GoodsIntroFont: FontProperty = new FontProperty() // 商品简介文字属性
    public GoodIntroView: Viewport = new Viewport() // 商品简介视窗信息
    public GoodBack: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城\\商城_商品底板.png'}) // 商品简介视窗信息
    public GoodsBack_X: number = 0 // 商品窗格底板X坐标
    public GoodsBack_Y: number = 0 // 商品窗格底板Y坐标
    public GoodsBack_W: number = 0 // 商品窗格底板宽度
    public GoodsBack_H: number = 0 // 商品窗格底板高度
    public Preview: FileName = new FileName({type: FileName.DEF_TYPE, name: ''}) // 预览图
    public Preview_X: number = 0 // 预览图X坐标
    public Preview_Y: number = 0 // 预览图Y坐标
    public Preview_W: number = 0 // 预览图宽度
    public Preview_H: number = 0 // 预览图高度
    public PreviewBack: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城\\商城_商品背景图.png'}) // 预览图
    public PreviewBack_X: number = 0 // 预览图底图X坐标
    public PreviewBack_Y: number = 0 // 预览图底图Y坐标
    public PreviewBack_W: number = 0 // 预览图底图宽度
    public PreviewBack_H: number = 0 // 预览图底图高度
    public Flower_X: number = 0 // 鲜花X坐标
    public Flower_Y: number = 0 // 鲜花Y坐标
    public BuyBtn: AvgButtonIndex = new AvgButtonIndex() // 购买按钮
    public BoughtBtn: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城\\商城_已购买.png'}) // 已购买图片
    public NoUpPic: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城\\商城_未上架.png'}) // 未上架图片片
    public CanBuyRepeat: boolean = false // 是否可以重复购买
    public Good_Status: GoodsStatus = GoodsStatus.NotUp // 商品状态
    public IsUnlockSpirit: boolean = false // 是否解体力锁
    public IsFreeWithTime: boolean = false // 是否限免
    public GoodProperty: string = '' // 是否限免
    public PropertyList: Array<GoodPropertyModel> = []
    public ExpandStr: string = '' // 扩展字段

    readVersionedOui(reader: FileReader): void {
        this.GoodsId = reader.readInt()
        this.GoodsBack_X = reader.readInt()
        this.GoodsBack_Y = reader.readInt()
        this.GoodsName = reader.readString()
        this.GoodsFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsName_X = reader.readInt()
        this.GoodsName_Y = reader.readInt()
        this.GoodsType = reader.readInt()
        this.GoodsPrice = reader.readInt()
        this.GoodsPriceFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsPrice_X = reader.readInt()
        this.GoodsPrice_Y = reader.readInt()
        this.GoodsIntro = reader.readString()
        this.GoodsIntroFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodIntroView.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsBack_W = reader.readInt()
        this.GoodsBack_H = reader.readInt()
        this.Preview.readVersionedOui(reader.readObj(reader.readInt()))
        this.Preview_X = reader.readInt()
        this.Preview_Y = reader.readInt()
        this.Preview_W = reader.readInt()
        this.Preview_H = reader.readInt()
        this.PreviewBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.PreviewBack_X = reader.readInt()
        this.PreviewBack_Y = reader.readInt()
        this.PreviewBack_W = reader.readInt()
        this.PreviewBack_H = reader.readInt()
        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()
        this.BuyBtn.readVersionedOui(reader.readObj(reader.readInt()))
        this.BoughtBtn.readVersionedOui(reader.readObj(reader.readInt()))
        this.NoUpPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.CanBuyRepeat = Boolean(reader.readInt())
        this.Good_Status = reader.readInt()
        this.IsUnlockSpirit = Boolean(reader.readInt())
        this.IsFreeWithTime = Boolean(reader.readInt())
        this.GoodProperty = reader.readString()

        const count = reader.readInt()
        if (count > 0) {
            for (let index = 0; index < count; index++) {
                const goodProperty = new GoodPropertyModel()
                goodProperty.readVersionedOui(reader.readObj(reader.readInt()))
                this.PropertyList.push(goodProperty)
            }
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.GoodsId)
        writer.writeInt(this.GoodsBack_X)
        writer.writeInt(this.GoodsBack_Y)
        writer.writeString(this.GoodsName)
        this.GoodsFont.writeVersionedOui(writer)
        writer.writeInt(this.GoodsName_X)
        writer.writeInt(this.GoodsName_Y)
        writer.writeInt(this.GoodsType)
        writer.writeInt(this.GoodsPrice)
        this.GoodsPriceFont.writeVersionedOui(writer)
        writer.writeInt(this.GoodsPrice_X)
        writer.writeInt(this.GoodsPrice_Y)
        writer.writeString(this.GoodsIntro)
        this.GoodsIntroFont.writeVersionedOui(writer)
        this.GoodIntroView.writeVersionedOui(writer)
        this.GoodBack.writeVersionedOui(writer)
        writer.writeInt(this.GoodsBack_W)
        writer.writeInt(this.GoodsBack_H)
        this.Preview.writeVersionedOui(writer)
        writer.writeInt(this.Preview_X)
        writer.writeInt(this.Preview_Y)
        writer.writeInt(this.Preview_W)
        writer.writeInt(this.Preview_H)
        this.PreviewBack.writeVersionedOui(writer)
        writer.writeInt(this.PreviewBack_X)
        writer.writeInt(this.PreviewBack_Y)
        writer.writeInt(this.PreviewBack_W)
        writer.writeInt(this.PreviewBack_H)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        this.BuyBtn.writeVersionedOui(writer)
        this.BoughtBtn.writeVersionedOui(writer)
        this.NoUpPic.writeVersionedOui(writer)
        writer.writeInt(this.CanBuyRepeat ? 1 : 0)
        writer.writeInt(this.Good_Status)
        writer.writeInt(this.IsUnlockSpirit ? 1 : 0)
        writer.writeInt(this.IsFreeWithTime ? 1 : 0)
        writer.writeString(this.GoodProperty)

        writer.writeInt(this.PropertyList.length)
        for (let i = 0; i < this.PropertyList.length; i++) {
            const goodProperty = this.PropertyList[i]
            goodProperty.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.GoodsId)
        writer.writeInt(this.GoodsBack_X)
        writer.writeInt(this.GoodsBack_Y)
        writer.writeString(this.GoodsName)
        this.GoodsFont.writeMallBin(writer)
        writer.writeInt(this.GoodsName_X)
        writer.writeInt(this.GoodsName_Y)
        writer.writeInt(this.GoodsType)
        writer.writeInt(this.GoodsPrice)
        this.GoodsPriceFont.writeMallBin(writer)
        writer.writeInt(this.GoodsPrice_X)
        writer.writeInt(this.GoodsPrice_Y)
        writer.writeString(this.GoodsIntro)
        this.GoodsIntroFont.writeMallBin(writer)
        this.GoodIntroView.writeMallBin(writer)
        this.GoodBack.writeMallBin(writer)
        writer.writeInt(this.GoodsBack_W)
        writer.writeInt(this.GoodsBack_H)
        this.Preview.writeMallBin(writer)
        writer.writeInt(this.Preview_X)
        writer.writeInt(this.Preview_Y)
        writer.writeInt(this.Preview_W)
        writer.writeInt(this.Preview_H)
        this.PreviewBack.writeMallBin(writer)
        writer.writeInt(this.PreviewBack_X)
        writer.writeInt(this.PreviewBack_Y)
        writer.writeInt(this.PreviewBack_W)
        writer.writeInt(this.PreviewBack_H)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        this.BuyBtn.writeMallBin(writer)
        this.BoughtBtn.writeMallBin(writer)
        this.NoUpPic.writeMallBin(writer)
        writer.writeInt(this.CanBuyRepeat ? 1 : 0)
        writer.writeInt(this.Good_Status)
        writer.writeInt(this.IsUnlockSpirit ? 1 : 0)
        writer.writeInt(this.IsFreeWithTime ? 1 : 0)
        writer.writeString(this.GoodProperty)
        writer.writeInt(this.PropertyList.length)
        for (const goodProperty of this.PropertyList) {
            goodProperty.writeMallBin(writer)
        }

        writer.writerLength()
    }
}
export default Goods
